import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Traduzioni italiane
const it = {
  // Navbar
  home: 'Home',
  about: 'Chi Siamo',
  projects: 'Progetti',
  services: 'Servizi',
  contact: 'Contatti',
  admin: 'Admin',
  login: 'Login',
  logout: 'Logout',
  
  // Home
  'home.welcome': 'Benvenuti in Cogeis',
  'home.description': '30 anni nel settore delle costruzioni portando a risultato le vostre idee.',
  'home.discoverMore': 'Scopri di più',
  heroTitle: 'COGEIS',
  heroSubtitle: 'Consulenza e Gestione Immobiliare e Servizi',
  heroDescription: 'Specialisti nella gestione di progetti di ristrutturazione, riqualificazione energetica e direzione lavori',
  viewProjects: 'Vedi i Progetti',
  contactUs: 'Contattaci',
  
  // About Us
  'about.title': 'About Us',
  'about.weAre': 'SIAMO',
  'about.weAreText': 'Un\'impresa di costruzioni composta da un team di tecnici, ingegneri, architetti e project manager, con più di 30 anni di esperienza nel settore.',
  'about.weCreate': 'CREIAMO',
  'about.weCreateText': 'Valore per i nostri clienti, garantendo processi efficienti ed essendo sempre un passo avanti.',
  'about.weCommit': 'CI IMPEGNIAMO',
  'about.weCommitText': 'a migliorare l\'intero settore edile, alzando il livello per noi stessi e ispirando gli altri a fare lo stesso.',
  'about.values': 'VALORI',
  'about.valuesText': 'Ogni progetto, così come ognuno dei nostri clienti, è unico e il nostro compito è agire nel migliore interesse per soddisfare le esigenze e le aspettative individuali. Abbiamo a cuore la collaborazione efficace e la comunicazione onesta nei nostri progetti.',
  'about.workMethod': 'IL NOSTRO METODO DI LAVORO',
  'about.workMethodText': 'La nostra ambizione è crescere e migliorare costantemente i nostri servizi. Per garantire efficacia e trasparenza, utilizziamo tecnologie avanzate per la pianificazione e il controllo degli imprevisti. Grazie a una piattaforma digitale integrata, riuniamo l\'intero team di progetto in un unico ambiente online, dove è possibile pianificare, monitorare e gestire i processi in tempo reale.',
  aboutTitle: 'Chi Siamo',
  aboutSubtitle: 'La nostra storia e i nostri valori',
  aboutDescription: 'COGEIS è un\'azienda specializzata nella consulenza e gestione di progetti immobiliari, con particolare focus su ristrutturazioni, riqualificazioni energetiche e direzione lavori.',
  
  // Projects
  projectsTitle: 'I Nostri Progetti',
  projectsSubtitle: 'Scopri i nostri lavori più importanti',
  allProjects: 'Tutti i Progetti',
  renovation: 'Ristrutturazione',
  commercial: 'Commerciale',
  residential: 'Residenziale',
  other: 'Altro',
  completed: 'Completato',
  inProgress: 'In Corso',
  pending: 'In Attesa',
  cancelled: 'Annullato',
  
  // Services
  'services.title': 'SERVIZI',
  'services.companyServices': 'SERVIZI D\'IMPRESA',
  'services.newConstruction': 'Nuove costruzioni',
  'services.renovation': 'Ristrutturazione',
  'services.restoration': 'Interventi di restauro e risanamento',
  'services.plantEngineering': 'Impiantistica',
  'services.photovoltaic': 'Installazione di impianti fotovoltaici',
  'services.siteManagement': 'Gestione cantiere / organizzazione logistica',
  'services.technicalServices': 'SERVIZI TECNICI',
  'services.projectManagement': 'GESTIONE DEI PROGETTI DI COSTRUZIONE',
  'services.qualityManagement': 'GESTIONE DELLA QUALITÀ NELLE COSTRUZIONI',
  'services.timeManagement': 'Gestione di tempi, qualità e budget',
  'services.designManagement': 'Gestione della progettazione',
  'services.contractManagement': 'Gestione dei contratti',
  'services.procurementManagement': 'Gestione degli approvvigionamenti',
  'services.constructionManagement': 'Gestione della costruzione',
  'services.defectPrevention': 'Prevenzione e risoluzione dei difetti',
  'services.riskManagement': 'Analisi e gestione dei rischi',
  'services.strategicAnalysis': 'Analisi strategica e definizione del progetto',
  'services.technicalDirection': 'Direzione tecnica dei lavori',
  'services.qualityPlan': 'Piano della qualità e gestione delle priorità',
  'services.qualityDocumentation': 'Gestione della documentazione qualitativa',
  'services.defectManagement': 'Prevenzione e gestione dei difetti tramite tecnologie informatiche',
  servicesTitle: 'I Nostri Servizi',
  servicesSubtitle: 'Soluzioni complete per i tuoi progetti',
  
  // Contact
  'contact.title': 'Contattaci',
  'contact.description': 'Puoi contattarci al numero 081 578 0492 o alla mail info@cogeis.it',
  'contact.whereWeAre': 'Dove Siamo',
  'contact.address': 'Via Raffaele Morghen, 181, 80129 Napoli NA',
  contactTitle: 'Contattaci',
  contactSubtitle: 'Siamo qui per aiutarti',
  name: 'Nome',
  email: 'Email',
  message: 'Messaggio',
  send: 'Invia',
  address: 'Indirizzo',
  phone: 'Telefono',
  
  // Footer
  allRightsReserved: 'Tutti i diritti riservati',
  
  // Common
  loading: 'Caricamento...',
  error: 'Errore',
  success: 'Successo',
  close: 'Chiudi',
  save: 'Salva',
  edit: 'Modifica',
  delete: 'Elimina',
  cancel: 'Annulla',
  back: 'Indietro',
  next: 'Avanti',
  previous: 'Precedente',
  
  // Project Details
  projectDetails: 'Dettagli Progetto',
  client: 'Cliente',
  year: 'Anno',
  location: 'Località',
  status: 'Stato',
  features: 'Caratteristiche',
  projectValue: 'Valore Progetto',
  squareMeters: 'Metri Quadrati',
  
  // Staff
  ourTeam: 'Il Nostro Team',
  teamSubtitle: 'Conosci i professionisti che lavorano con noi',
  role: 'Ruolo',
  bio: 'Biografia',
  specializations: 'Specializzazioni',
  experience: 'Esperienza',
  
  // Admin
  adminPanel: 'Pannello Amministratore',
  dashboard: 'Dashboard',
  manageProjects: 'Gestisci Progetti',
  manageStaff: 'Gestisci Staff',
  manageServices: 'Gestisci Servizi',
  addNew: 'Aggiungi Nuovo',
  editItem: 'Modifica Elemento',
  deleteItem: 'Elimina Elemento',
  
  // Categories
  buildingRenovation: 'Ristrutturazione Fabbricati',
  retailHotelServices: 'Negozi Hotel Servizi',
  interiorRenovation: 'Ristrutturazione Interni',
  
  // Sidebar Tooltips
  sidebarAbout: 'Chi Siamo',
  sidebarServices: 'Servizi',
  sidebarContact: 'Contatti',
  sidebarProjects: 'Progetti'
};

// Traduzioni inglesi
const en = {
  // Navbar
  home: 'Home',
  about: 'About',
  projects: 'Projects',
  services: 'Services',
  contact: 'Contact',
  admin: 'Admin',
  login: 'Login',
  logout: 'Logout',
  
  // Home
  'home.welcome': 'Welcome to Cogeis',
  'home.description': '30 years in the construction sector bringing your ideas into results.',
  'home.discoverMore': 'Discover More',
  heroTitle: 'COGEIS',
  heroSubtitle: 'Consulting and Real Estate Management and Services',
  heroDescription: 'Specialists in renovation project management, energy requalification and construction supervision',
  viewProjects: 'View Projects',
  contactUs: 'Contact Us',
  
  // About Us
  'about.title': 'About Us',
  'about.weAre': 'WE ARE',
  'about.weAreText': 'A construction company with over 30 years of experience, made up of a qualified team of engineers, architects, technicians, and project managers.',
  'about.weCreate': 'WE CREATE',
  'about.weCreateText': 'Value for our clients by ensuring efficient processes, innovative solutions, and by always staying one step ahead of market demands.',
  'about.weCommit': 'OUR MISSION',
  'about.weCommitText': 'We are committed to continuously improving the construction industry, raising our own standards and inspiring others to do the same.',
  'about.values': 'OUR VALUES',
  'about.valuesText': 'Every project is unique, just like every client. That is why we always act in the best interest of our partners, striving to meet their specific needs and expectations. We believe that effective collaboration and honest communication are the foundation of successful projects.',
  'about.workMethod': 'OUR WORK METHOD',
  'about.workMethodText': 'Our ambition is to constantly learn, grow, and improve the level of service we deliver. To ensure efficiency and transparency, we use advanced technologies for planning and managing unforeseen events. Through an integrated digital platform, we bring the entire project team together in a single online environment, where processes can be planned, monitored, and managed in real time.',
  aboutTitle: 'About Us',
  aboutSubtitle: 'Our story and our values',
  aboutDescription: 'COGEIS is a company specialized in consulting and managing real estate projects, with particular focus on renovations, energy requalifications and construction supervision.',
  
  // Projects
  projectsTitle: 'Our Projects',
  projectsSubtitle: 'Discover our most important works',
  allProjects: 'All Projects',
  renovation: 'Renovation',
  commercial: 'Commercial',
  residential: 'Residential',
  other: 'Other',
  completed: 'Completed',
  inProgress: 'In Progress',
  pending: 'Pending',
  cancelled: 'Cancelled',
  
  // Services
  'services.title': 'SERVICES',
  'services.companyServices': 'COMPANY SERVICES',
  'services.newConstruction': 'New construction',
  'services.renovation': 'Renovation',
  'services.restoration': 'Restoration and rehabilitation interventions',
  'services.plantEngineering': 'Plant engineering',
  'services.photovoltaic': 'Photovoltaic system installation',
  'services.siteManagement': 'Site management / logistics organization',
  'services.technicalServices': 'TECHNICAL SERVICES',
  'services.projectManagement': 'CONSTRUCTION PROJECT MANAGEMENT',
  'services.qualityManagement': 'QUALITY MANAGEMENT IN CONSTRUCTION',
  'services.timeManagement': 'Time, quality and budget management',
  'services.designManagement': 'Design management',
  'services.contractManagement': 'Contract management',
  'services.procurementManagement': 'Procurement management',
  'services.constructionManagement': 'Construction management',
  'services.defectPrevention': 'Defect prevention and resolution',
  'services.riskManagement': 'Risk analysis and management',
  'services.strategicAnalysis': 'Strategic analysis and project definition',
  'services.technicalDirection': 'Technical direction of works',
  'services.qualityPlan': 'Quality plan and priority management',
  'services.qualityDocumentation': 'Quality documentation management',
  'services.defectManagement': 'Defect prevention and management through information technologies',
  servicesTitle: 'Our Services',
  servicesSubtitle: 'Complete solutions for your projects',
  
  // Contact
  'contact.title': 'Contact Us',
  'contact.description': 'You can contact us at 081 578 0492 or at info@cogeis.it',
  'contact.whereWeAre': 'Where We Are',
  'contact.address': 'Via Raffaele Morghen, 181, 80129 Napoli NA',
  contactTitle: 'Contact Us',
  contactSubtitle: 'We are here to help you',
  name: 'Name',
  email: 'Email',
  message: 'Message',
  send: 'Send',
  address: 'Address',
  phone: 'Phone',
  
  // Footer
  allRightsReserved: 'All rights reserved',
  
  // Common
  loading: 'Loading...',
  error: 'Error',
  success: 'Success',
  close: 'Close',
  save: 'Save',
  edit: 'Edit',
  delete: 'Delete',
  cancel: 'Cancel',
  back: 'Back',
  next: 'Next',
  previous: 'Previous',
  
  // Project Details
  projectDetails: 'Project Details',
  client: 'Client',
  year: 'Year',
  location: 'Location',
  status: 'Status',
  features: 'Features',
  projectValue: 'Project Value',
  squareMeters: 'Square Meters',
  
  // Staff
  ourTeam: 'Our Team',
  teamSubtitle: 'Meet the professionals who work with us',
  role: 'Role',
  bio: 'Biography',
  specializations: 'Specializations',
  experience: 'Experience',
  
  // Admin
  adminPanel: 'Admin Panel',
  dashboard: 'Dashboard',
  manageProjects: 'Manage Projects',
  manageStaff: 'Manage Staff',
  manageServices: 'Manage Services',
  addNew: 'Add New',
  editItem: 'Edit Item',
  deleteItem: 'Delete Item',
  
  // Categories
  buildingRenovation: 'Building Renovation',
  retailHotelServices: 'Retail Hotel Services',
  interiorRenovation: 'Interior Renovation',
  
  // Sidebar Tooltips
  sidebarAbout: 'About Us',
  sidebarServices: 'Services',
  sidebarContact: 'Contact',
  sidebarProjects: 'Projects'
};

const resources = {
  it: {
    translation: it
  },
  en: {
    translation: en
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'it',
    debug: false,
    
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
    
    interpolation: {
      escapeValue: false,
    },
    
    react: {
      useSuspense: false,
    },
  });

export default i18n;
